var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#FF9D42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53984 5.14645C9.63361 5.05268 9.76079 5 9.8934 5H16.1066C16.2392 5 16.3664 5.05268 16.4602 5.14645L20.8536 9.53984C20.9473 9.63361 21 9.76079 21 9.8934V16.1066C21 16.2392 20.9473 16.3664 20.8536 16.4602L16.4602 20.8536C16.3664 20.9473 16.2392 21 16.1066 21H9.8934C9.76079 21 9.63361 20.9473 9.53984 20.8536L5.14645 16.4602C5.05268 16.3664 5 16.2392 5 16.1066V9.8934C5 9.76079 5.05268 9.63361 5.14645 9.53984L9.53984 5.14645ZM10.1005 6L6 10.1005V15.8995L10.1005 20H15.8995L20 15.8995V10.1005L15.8995 6H10.1005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64645 9.64645C9.84171 9.45118 10.1583 9.45118 10.3536 9.64645L13 12.2929L15.6464 9.64645C15.8417 9.45118 16.1583 9.45118 16.3536 9.64645C16.5488 9.84171 16.5488 10.1583 16.3536 10.3536L13.7071 13L16.3536 15.6464C16.5488 15.8417 16.5488 16.1583 16.3536 16.3536C16.1583 16.5488 15.8417 16.5488 15.6464 16.3536L13 13.7071L10.3536 16.3536C10.1583 16.5488 9.84171 16.5488 9.64645 16.3536C9.45118 16.1583 9.45118 15.8417 9.64645 15.6464L12.2929 13L9.64645 10.3536C9.45118 10.1583 9.45118 9.84171 9.64645 9.64645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveActionIcon);
export default __webpack_public_path__ + "static/media/remove-action-icon.8430d3778f230b0031b987b0d9223db0.svg";
export { ForwardRef as ReactComponent };